<div class="mt-4 mb-3 px-4 d-flex align-items-center">
  <h5 class="font-trueno-bold font-24" id="login-modal">Modifier la photo de couverture</h5>
  <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="closeModal()">
    <span class="material-icons-outlined text-black ">close</span>
  </button>
</div>

<div class="d-flex flex-column p-3 align-items-center justify-content-center">
  <h6>Photo initiale</h6>
  <img src="https://via.placeholder.com/350x150" alt="">

  <h6 class="mt-4 pt-1">
      <span class="material-icons-outlined pointer v-middle" *ngIf="editCoverType || preview"
            (click)="selectEditCoverType(null)" title="Revenir au menu de sélection">chevron_left</span>
    Nouvelle photo
  </h6>

  <!--  Choix du type de modification  -->
  <div class="d-flex flex-column align-items-center w-100 gap-16" *ngIf="!editCoverType && !preview">
    <div class="w-50 d-flex">
      <label for="uploadBtn" class="file_up_label w-100">
        <span class="btn btn-primary border-0 w-100">Télécharger une image</span>
      </label>
      <input id="uploadBtn" type="file" class="file_upload" accept="image/*" (change)="selectFile($event)"/>
    </div>

    <button type="button" class="btn w-50 btn-outline-primary" (click)="selectEditCoverType('url')">Upload à partir d'une URL</button>
<!--    <button type="button" class="btn w-50 btn-outline-primary" (click)="selectEditCoverType('selection')">Sélectionner une image</button>-->
  </div>

<!-- Prévisu  -->
  <img [src]="preview" class="preview w-100" alt="">

  <!--  Menu a partir d'une URL  -->
  <div *ngIf="editCoverType == 'url'" class="w-75 mt-2">
    <mat-form-field>
      <mat-label>URL de la photo</mat-label>
      <input matInput placeholder="écrire ici" [(ngModel)]="preview">
    </mat-form-field>
  </div>

  <!--  Menu sélection d'image  -->
  <div *ngIf="editCoverType == 'selection'">
    selection ici
  </div>


<!--  <div class="row" *ngIf="editCoverType == 'upload'">-->
<!--     <div class="col-4">-->
<!--      <button class="btn btn-success btn-sm float-right" [disabled]="!selectedFiles" (click)="upload()">Upload</button>-->
<!--    </div>-->
<!--  </div>-->



<!--  <div *ngIf="currentFile && progress" class="progress my-3">-->
<!--    <div class="progress-bar progress-bar-info" role="progressbar" attr.aria-valuenow="{{ progress }}"-->
<!--      aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ width: progress + '%' }">-->
<!--      {{ progress }}%-->
<!--    </div>-->
<!--  </div>-->

  <div *ngIf="message" class="alert alert-secondary" role="alert"> {{ message }} </div>

  <!--  Boutons de décision finale  -->
  <div class="d-flex justify-content-between mt-5 w-100">
    <button type="button" class="btn border-0 lightGray" (click)="closeModal()">Fermer</button>
    <button type="submit" class="btn btn-primary" [disabled]="!preview" (click)="upload()">Enregister</button>
  </div>


</div>



